module.exports = __webpack_public_path__ + "static/media/SocialImage.171d6636.png";